import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js";
import "./polyfill";
import "./tailwind.css";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { icons } from "./assets/icons";
import { Provider } from "react-redux";
import { store, persistor } from "./redux_setup/store";
import { PersistGate } from "redux-persist/integration/react";
import { NotificationProvider } from "./context/NotificationContext";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoadingComponent from "./views/components/ui/LoadingComponent";

window.process = {
  env: {
    NODE_ENV: "production",
  },
};

React.icons = icons;

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={<LoadingComponent isActive={true} />} persistor={persistor}>
      <NotificationProvider>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <App />
        </GoogleOAuthProvider>
      </NotificationProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);